import React from "react";
import Alert from "react-bootstrap/lib/Alert";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import { PaperSessionDetailModalBody } from "./PaperSessionDetailModalBody";
import { BreakSessionDetailModalBody } from "./BreakSessionDetailModalBody";
import { TutorialSessionDetailModalBody } from "./TutorialSessionDetailModalBody";
import { WorkshopSessionDetailModalBody } from "./WorkshopSessionDetailModalBody";
import { PanelSessionDetailModalBody } from "./PanelSessionDetailModalBody";
import { InvitedTalkSessionDetailModalBody } from "./InvitedTalkDetailModalBody";
import { CustomSessionDetailModalBody } from "./CustomSessionDetailModalBody";

export class SessionModal extends React.Component {
    constructor(props) {
        super(props);
        let newSession =
            this.props.selectedSessionType === "Paper"
                ? { panel_color: "#d9edf7" }
                : {};

        this.state = {
            selectedSessionType: this.props.selectedSessionType
                ? this.props.selectedSessionType
                : "",
            newSession: this.props.session
                ? this.props.session.data
                : newSession,
            alertShow: false,
            alertMessage: "",
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.showAlert = this.showAlert.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    handleClose() {}

    handleSave() {}

    handleInputChange(event) {
        const target = event.target;
        this.setState((state, props) => {
            const newSession = { ...state.newSession };
            newSession[target.name] = target.value;
            return { newSession };
        });
    }

    showAlert(message) {
        this.setState((state, props) => ({
            alertShow: true,
            alertMessage: message,
        }));
    }

    handleSelectChange(event) {
        const value = event.target.value;
        this.setState((state, props) => {
            return { selectedSessionType: value };
        });
    }

    getSessionTypeSelect() {
        const options = Object.keys(this.props.sessionTypes).map(
            (sessionType, index) => {
                if (new Set(["Paper", "Break"]).has(sessionType)) return null;
                return (
                    <option key={index} value={sessionType}>
                        {sessionType}
                    </option>
                );
            }
        );

        return (
            <React.Fragment>
                <label>Choose a session type:</label>{" "}
                <select
                    onChange={this.handleSelectChange}
                    value={this.state.selectedSessionType}
                >
                    <option value=""> -- select an option --</option>
                    {options}
                </select>
                <br />
                <br />
            </React.Fragment>
        );
    }

    render() {
        const { selectedSessionType } = this.state;

        let sessionTypeSelect;
        if (!selectedSessionType || this.props.forceTypeSelection)
            sessionTypeSelect = this.getSessionTypeSelect();

        let inputFields;
        if (selectedSessionType) {
            // this.props.sessionTypes is defined in SessionType.php!
            inputFields = this.props.sessionTypes[
                selectedSessionType
            ].fields.map((field, index) => {
                return (
                    <React.Fragment key={index}>
                        <span>{field.display_name}</span>
                        <input
                            name={field.name}
                            type={field.input_type}
                            value={
                                this.state.newSession[field.name] ??
                                field.default
                            }
                            onChange={this.handleInputChange}
                            className="form-control"
                        />
                    </React.Fragment>
                );
            });
        }

        let alert;
        if (this.state.alertShow) {
            alert = (
                <React.Fragment>
                    <br />
                    <Alert bsStyle="danger">{this.state.alertMessage}</Alert>
                </React.Fragment>
            );
        }

        return (
            <Modal show={this.props.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {sessionTypeSelect}
                    {inputFields}
                    {alert}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.handleClose}>
                        Close
                    </Button>
                    <Button bsStyle="primary" onClick={this.handleSave}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export function ShowSessionModal(props) {
    /**
     * Returns the component that has the session information according to session type.
     * @param session
     * @returns {*}
     */
    const detailSession = (session) => {
        switch (session.type) {
            case "Paper":
                return <PaperSessionDetailModalBody paperSession={session} />;
            case "Break":
                return <BreakSessionDetailModalBody session={session} />;
            case "Tutorial":
                return (
                    <TutorialSessionDetailModalBody
                        session={session}
                        handleEditSessionClick={props.handleEditSessionClick}
                    />
                );
            case "Workshop":
            case "Workshop2":
                return (
                    <WorkshopSessionDetailModalBody
                        session={session}
                        handleEditSessionClick={props.handleEditSessionClick}
                    />
                );
            case "Panel":
                return (
                    <PanelSessionDetailModalBody
                        session={session}
                        handleEditSessionClick={props.handleEditSessionClick}
                    />
                );
            case "Invited Talk":
                return (
                    <InvitedTalkSessionDetailModalBody
                        session={session}
                        handleEditSessionClick={props.handleEditSessionClick}
                    />
                );
            case "Custom":
                return (
                    <CustomSessionDetailModalBody
                        session={session}
                        handleEditSessionClick={props.handleEditSessionClick}
                    />
                );
        }
    };

    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Session Information
                    {props.session && props.session.id
                        ? ` (${props.session.id})`
                        : ""}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>{detailSession(props.session)}</Modal.Body>
        </Modal>
    );
}
